import { createContext, useContext } from "react";
import AccountStore from "./accountStore";
import AnnouncementStore from "./announcementStore";
import BlogStore from "./blogStore";
import AuthenticationStore from "./authenticationStore";
import AvailabilityStore from "./availabilityStore";
import BookingStore from "./bookingStore";
import CategoryStore from "./categoryStore";
import ContactStore from "./contactStore";
import FavoriteStore from "./favoriteStore";
import PromotionStore from "./promotionStore";
import UnavailabilityStore from "./unavailabilityStore";
import RateStore from "./rateStore";
import RequestStore from "./requestStore";
import ServiceStore from "./serviceStore";
import TenantStore from "./tenantStore";
import SurveyStore from "./surveyStore";
import TownStore from "./townStore";
import UserStore from "./userStore";

interface Store {
  blogStore: BlogStore;
  rateStore: RateStore;
  userStore: UserStore;
  bookingStore: BookingStore;
  contactStore: ContactStore;
  serviceStore: ServiceStore;
  requestStore: RequestStore;
  tenantStore: TenantStore;
  authStore: AuthenticationStore;
  accountStore: AccountStore;
  unavailabilityStore: UnavailabilityStore;
  availabilityStore: AvailabilityStore;
  categoryStore: CategoryStore;
  favoriteStore: FavoriteStore;
  announcementStore: AnnouncementStore;
  promotionStore: PromotionStore;
  surveyStore: SurveyStore;
  townStore: TownStore;
}

export const store: Store = {
  blogStore: new BlogStore(),
  rateStore: new RateStore(),
  userStore: new UserStore(),
  bookingStore: new BookingStore(),
  contactStore: new ContactStore(),
  serviceStore: new ServiceStore(),
  requestStore: new RequestStore(),
  tenantStore: new TenantStore(),
  authStore: new AuthenticationStore(),
  accountStore: new AccountStore(),
  unavailabilityStore: new UnavailabilityStore(),
  availabilityStore: new AvailabilityStore(),
  categoryStore: new CategoryStore(),
  favoriteStore: new FavoriteStore(),
  announcementStore: new AnnouncementStore(),
  promotionStore: new PromotionStore(),
  surveyStore: new SurveyStore(),
  townStore: new TownStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
